import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { WordpressService } from './services/wordpress.service';
import { HttpModule } from '@angular/http';

import { ContactsComponent } from './contacts/contacts.component';
import { FooterComponent } from './footer/footer.component';
import { NavbarComponent } from './navbar/navbar.component';
import { OverviewComponent } from './overview/overview.component';
import { SurveysComponent } from './surveys/surveys.component';
import { CardComponent } from './surveys/card/card.component';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { MainFilterPipe } from './main-filter.pipe';
import { FormsModule } from '@angular/forms';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { ActiveComponent } from './active/active.component';
import { WhoAreWeComponent } from './who-are-we/who-are-we.component';
import { MyServicesComponent } from './my-services/my-services.component';
import { routing } from './app-routing.module';
import { HomeComponent } from './home/home.component';
import { RouterModule } from '@angular/router';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { SubscribeButtonComponent } from './subscribe-button/subscribe-button.component';
import { NguCarouselModule } from '@ngu/carousel';



@NgModule({
  declarations: [
    AppComponent,
    ContactsComponent,
    FooterComponent,
    NavbarComponent,
    OverviewComponent,
    SurveysComponent,
    CardComponent,
    MainFilterPipe,
    ActiveComponent,
    WhoAreWeComponent,
    MyServicesComponent,
    HomeComponent,
    SubscribeButtonComponent,
  ],
  imports: [
    CarouselModule,
    FormsModule,
    BrowserModule,
    HttpModule,
    ScrollToModule.forRoot(),
    ModalModule.forRoot(),
    routing,
    BsDropdownModule.forRoot(),
    NguCarouselModule

  ],
  providers: [ WordpressService, BsModalService, BsModalRef],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Users/gdb/Documents/work/garrido-angular/garrido-front/src/app/app.module.ts